import { get, post, put } from "../Config";

export function DDSegmentation() {
  return get({ url: `/api/hu/v1/dropdown/segmentation`});
}
